export interface SurplusLinesPlanDesignModel{
    CompassId: number;
    OpportunityId: number;
    QuestionnaireId: string;

    Name: string;
    AnnualPremium: number;
    YearOneCost: number;
    Order: number;
    SLTaxes: number;
    SLFees: number;
    SLTaxesLabel: string;
    OtherFees: number;
    Selected: boolean;
    GITypeCode: string;
    GIType: string;

    TTDMaxBenefit: number;
    TTDMinBenefit: number;
    TTDSelectedBenefit: number;
    TTDIncremental: boolean;
    TTDIncrement: number;
    TTDSliderConfig: any;

    PTDMaxBenefit: number;
    PTDMinBenefit: number;
    PTDSelectedBenefit: number;
    PTDIncremental: boolean;
    PTDIncrement: number;
    PTDSliderConfig: any;

    SkipQuestionNums: string;

    Details: SurplusLinesPlanDetail[];

    rating: boolean;
    ptdDetails: SurplusLinesPlanDetail[];
    ttdDetails: SurplusLinesPlanDetail[];
    updateRating: boolean;
}

export class SurplusLinesPlanDesign implements SurplusLinesPlanDesignModel{
    CompassId: number= 0;
    OpportunityId: number = 0;
    QuestionnaireId: string = '';

    Name: string = '';
    AnnualPremium: number = 0;
    YearOneCost: number = 0;
    Order: number = 0;
    SLTaxes: number = 0;
    SLTaxesLabel: string = '';
    SLFees: number = 0;
    OtherFees: number = 0;
    Selected: boolean = false;
    GITypeCode: string = '';
    GIType: string = '';

    TTDMaxBenefit: number = 0;
    TTDMinBenefit: number = 0;
    TTDSelectedBenefit: number = 0;
    TTDIncremental: boolean = false;
    TTDIncrement: number = 0;
    TTDSliderConfig: any = {};

    PTDMaxBenefit: number = 0;
    PTDMinBenefit: number = 0;
    PTDSelectedBenefit: number = 0;
    PTDIncremental: boolean = false;
    PTDIncrement: number = 0;
    PTDSliderConfig: any = {};

    SkipQuestionNums: string = '';

    Details: SurplusLinesPlanDetail[] = [];

    rating: boolean = false;
    ptdDetails: SurplusLinesPlanDetail[] = [];
    ttdDetails: SurplusLinesPlanDetail[] = [];
    updateRating: boolean = false;
}

export interface SurplusLinesPlanDetailModel{
    DesignId: number;
    AttributeType: string;

    Attribute: string;
    Value: string;
    Order: number;
    Indent: boolean;
}

export class SurplusLinesPlanDetail implements SurplusLinesPlanDetailModel{
    DesignId: number = 0;
    AttributeType: string = '';

    Attribute: string = '';
    Value: string = '';
    Order: number = 0;
    Indent: boolean = false;
}

export interface SurplusLinesPlanDesignsRequestModel {
    OpportunityId: number;
    InsuredId: number;
    EarnedIncome: string;
    ExistingCoverages: SurplusLinesExistingCoverage[];
}

export class SurplusLinesPlanDesignsRequest implements SurplusLinesPlanDesignsRequestModel{
    OpportunityId: number = 0;
    InsuredId: number = 0;
    EarnedIncome: string = '';
    ExistingCoverages: SurplusLinesExistingCoverage[] = [];
    TTDElectedBenefit: string = '';
    TTDMonthlyBenefit: string = '';
    MinBenefit: string = '';
    Increment: string = '';
    EP: string = '';
    BenefitDuration: string = '';
    COLADuration: string = '';
    IDRDuration: string = '';
    EEBDuration: string = '';
    SLRDuration: string = '';
    SLRAmount: string = '';
    PLPDuration: string = '';
    PLPAmount: string = '';
    RCBDuration: string = '';
    RCBAmount: string = '';
}

export interface SurplusLinesExistingCoverageModel {
    Type: string;
    Amount: string;
    Payee: string;
}

export class SurplusLinesExistingCoverage implements SurplusLinesExistingCoverageModel {
    Type: string = '';
    Amount: string = '';
    Payee: string = '';
}